import React from 'react';
import './SidebarBlank.scss';

const SidebarBlank = () => {
    return (
        <div className="sidebarBlank col-sm-3 margin-b30">
            <div className="blankBox">
                <div className="animatedBackground headerWrap">
                    <div className="header"></div>
                </div>
                <div className="animatedBackground imageWrap">
                    <div className="image"></div>
                </div>
                <div className="footerWrap">
                    <div className="footerLeft">
                        <span className="animatedBackground" style={{ width: '200px', marginLeft: '6px', height: '15px', display: 'block', marginBottom: '5px' }}></span>
                        <span className="animatedBackground" style={{ width: '220px', marginLeft: '6px', height: '15px', display: 'block', marginBottom: '5px' }}></span>
                        <span className="animatedBackground" style={{ width: '240px', marginLeft: '6px', height: '15px', display: 'block', marginBottom: '5px' }}></span>
                    </div>
                </div>
                <div className="blankBox1">
                    <div className="col-md-12">
                        <div className="animatedBackground" style={{ width: '100%', marginBottom: '6px', height: '35px' }}></div>
                        <div className="animatedBackground" style={{ width: '100%', marginBottom: '6px', height: '35px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidebarBlank;
